import { format } from 'date-fns';
import type { DashboardSnapshot } from '@daily/shared';

const FALLBACK_LINES = ['A new day, soon.', 'Sleep well.', 'Tomorrow brings what it brings.'];

export function BackPageCard({ dashboard }: { dashboard: DashboardSnapshot }) {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const meta = (dashboard.headline as unknown as { lines?: string[] }).lines ?? FALLBACK_LINES;

  return (
    <div className="min-h-[calc(100vh-3.5rem)] rounded-lg p-12 text-white relative overflow-hidden">
      <svg
        className="absolute top-8 right-12 opacity-70"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden
      >
        <circle cx="34" cy="14" r="10" fill="#F5C97A" />
        <circle cx="36" cy="12" r="8" fill="#1F2D44" />
      </svg>
      <div className="flex flex-col gap-12 max-w-2xl mt-32">
        <span className="font-sans text-eyebrow uppercase tracking-[0.18em] text-white/40">
          Tomorrow brings…
        </span>
        <div className="flex flex-col gap-4">
          {meta.map((line, i) => (
            <p
              key={i}
              className="font-serif italic text-mustardSoft text-display-md leading-tight"
            >
              {line}
            </p>
          ))}
        </div>
      </div>
      <div className="absolute bottom-8 left-12 font-serif italic text-white/40 text-body-lg">
        {format(tomorrow, 'EEEE d MMMM')}
      </div>
    </div>
  );
}
